import classNames from 'classnames';
import React, { CSSProperties, useEffect, useState } from 'react';

type Props = {
  src: string;
  size?: number;
  style?: CSSProperties;
  className?: string;
};

const ProfileImage = (props: Props) => {
  const { src, size, style, className } = props;
  const [fallbackVisible, setFallbackVisible] = useState<boolean>(false);

  // Modify style
  const imgStyle = {
    ...(style || {}),
    width: `${size}px`,
    minWidth: `${size}px`,
    height: `${size}px`,
    minHeight: `${size}px`,
  };

  const handleImgError = (e) => {
    if (e.target?.style) {
      e.target.style.display = 'none';
    }
    setFallbackVisible(true);
  };

  useEffect(() => {
    if (!src) {
      setFallbackVisible(true);
    }
  }, []);

  // Render image
  return (
    <div className={classNames('profile-image', className)} style={imgStyle}>
      {/* image does not exist fallback */}
      <img
        src="/icons/avatar-placeholder.png"
        alt=""
        className={`profile-image-fallback ${!fallbackVisible ? 'profile-image-fallback--hidden' : ''}`}
      />

      {/* image */}
      <img src={src} alt="" onError={handleImgError} />
    </div>
  );
};

export default ProfileImage;
